import { render, staticRenderFns } from "./editTopic.vue?vue&type=template&id=3356e1a6"
import script from "./editTopic.vue?vue&type=script&lang=js"
export * from "./editTopic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports